import { FC, useContext, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { Organization } from '@kaizenplatform/intelligence-entity';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import { context as ConfigContext } from '../context/config';
import _TopBar from '../component/compound/TopBar';

type Props = { className?: string };

const TopBar: FC<Props> = ({ className }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);
  const config = useContext(ConfigContext);
  const [regex] = useState(new RegExp('/comment-board/.+'));

  const onChangeSelectedOrganization = useCallback(
    async (queryParams: string, orgId: string) => {
      await dependency.organizationUsecase.setLastAccessedOrganization(orgId);
      navigate(`${pathname}?${queryParams}`, { replace: true });
    },
    [navigate, pathname, dependency],
  );

  return (
    <_TopBar
      className={className}
      loadingOrganization={state.lastAccessedOrganization.fetching > 0}
      organization={state.lastAccessedOrganization.item}
      organizations={state.availableOrganizations.items}
      onChangeSelectedOrganization={onChangeSelectedOrganization}
      onClickSignOut={() => dependency.authenticationUsecase.signOut()}
      onClickAccountSettings={() => {
        const url = `${config.ID_WEB_URL}`;
        const win = window.open(url, '_blank');
        if (win !== null) {
          win.focus();
        }
      }}
      user={state.authentication.signedInUser}
      isCommentBoard={regex.test(pathname)}
    />
  );
};

export default TopBar;
